export default {"src":"/_next/static/media/canto.cb85e14f.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};